
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  subtitle?: string;
  title: string;
  alignment?: 'left' | 'center' | 'right';
  className?: string;
  gradient?: boolean;
}

export function SectionHeading({ 
  subtitle, 
  title, 
  alignment = 'center',
  className,
  gradient = false
}: SectionHeadingProps) {
  return (
    <div 
      className={cn(
        'mb-8',
        alignment === 'center' && 'text-center',
        alignment === 'right' && 'text-right',
        className
      )}
    >
      {subtitle && (
        <div className="inline-block px-3 py-1 text-xs font-medium tracking-wider rounded-full mb-2 uppercase text-taekwondo-blue bg-blue-50">
          {subtitle}
        </div>
      )}
      <h2 className={cn(
        "text-2xl md:text-3xl font-bold font-display",
        gradient ? "text-white bg-gradient-to-r from-taekwondo-red to-[#004499] px-3 py-1.5 rounded-lg" : ""
      )}>
        {title}
      </h2>
      <div className={cn(
        "h-1 w-16 mt-3",
        gradient ? "bg-taekwondo-red" : "bg-taekwondo-red",
        alignment === 'center' && 'mx-auto',
        alignment === 'right' && 'ml-auto'
      )} />
    </div>
  );
}
